import { useAuth } from '@/contexts/AuthContext';

export interface CurrentUser {
  id: string;
  email: string | null;
  profile: {
    id: string;
    first_name: string | null;
    last_name: string | null;
    username: string | null;
    avatar_url: string | null;
    role: string | null;
    bio: string | null;
  } | null;
}

export function useCurrentUser() {
  const { user, profile, isLoading } = useAuth();

  const currentUser: CurrentUser | null = user ? {
    id: user.id,
    email: user.email || null,
    profile: profile ? {
      id: profile.id,
      first_name: profile.first_name || null,
      last_name: profile.last_name || null,
      username: profile.username || null,
      avatar_url: profile.avatar_url || null,
      role: profile.role || null,
      bio: profile.bio || null,
    } : null,
  } : null;

  return {
    user: currentUser,
    isLoading,
    isAuthenticated: !!user,
    profile,
  };
}
